import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App, ConfigProvider } from 'antd';
import 'antd/dist/reset.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoot from './App';
import PWAInstallPrompt from './components/PWA/PWAInstallPrompt';
import PWARegister from './components/PWA/PWARegister';
import { AuthProvider } from './context/AuthProvider';
import './index.css';
import { store } from './store';

const rootElement = document.querySelector('#root');
if (!rootElement) {
  throw new Error('Cannot find root element with that id');
}
const root = createRoot(rootElement);
const queryClient = new QueryClient();

// Ensure globalThis is available for Ant Design
if (typeof globalThis !== 'undefined') {
  (globalThis as any).global = globalThis;
}

root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#1677ff',
          },
        }}
        prefixCls='ant'
      >
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AuthProvider>
            <PWARegister>
              <React.StrictMode>
                <App>
                  <AppRoot />
                </App>
                <PWAInstallPrompt />
              </React.StrictMode>
            </PWARegister>
          </AuthProvider>
        </Router>
      </ConfigProvider>
    </QueryClientProvider>
  </Provider>
);
